import {
  AfterViewInit,
  Component, computed,
  effect,
  ElementRef,
  HostListener,
  inject,
  Injector,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  REQUEST,
  RESPONSE_INIT,
  signal,
  untracked,
  ViewChild
} from '@angular/core';
import {DecimalPipe, isPlatformBrowser, isPlatformServer, NgClass, NgOptimizedImage, NgStyle} from '@angular/common';
import {toObservable} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {combineLatest, distinctUntilChanged, of, Subject, switchMap,tap} from 'rxjs';
import {catchError, takeUntil,map} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';

import {SpinnerService} from '../services/spinner.service';
import {ProductService} from '../services/product.service';
import {NotificationService} from '../notification/notification.service';
import {TypeOrderEnum} from '../enum/type-order.enum';
import {CategoryStore} from '../store/category.store';
import {PromosService} from '../services/promos.service';
import {ConfigurationStore} from '../store/configuration.store';
import {OrderContextStore} from '../store/order-context.store';
import {OrderComponent} from '../order/order.component';
import {BundleService} from '../services/bundle.service';
import {CartService} from '../services/cart.service';
import {NotificationType} from '../enum/notification-type.enum';
import {ProductFilterDialogComponent} from './product-filter-dialog/product-filter-dialog.component';
import {THEME_CONFIG} from '../../environments/tokens/theme.token';
import {TopNavbarComponent} from '../shared/top-navbar/top-navbar.component';
import {NavbarComponent} from '../shared/navbar/navbar.component';
import {MatIcon} from '@angular/material/icon';
import {MatFormField} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';
import {MatButton} from '@angular/material/button';
import {TenantService} from '../services/tenant.service';

import {AdvertisementService} from '../services/advertisement.service';
import {AuthenticationService} from '../services/authentication.service';
import {AdvertisementFlowService} from '../services/advertisement-flow.service';
import {CustomerService} from '../services/customer.service';
import {MatTooltip} from '@angular/material/tooltip';
import {LoyaltyPointComponent} from '../profil/loyalty-point/loyalty-point.component';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss',
  standalone: true,
  imports: [TopNavbarComponent,
    NavbarComponent,
    MatIcon,
    RouterLink,
    NgStyle,
    MatFormField,
    MatSelect,
    MatOption,
    MatButton,
    NgClass,
    MatTooltip,
    NgOptimizedImage]
})
export class ProductComponent implements OnInit, AfterViewInit, OnDestroy {
  private platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  isBrowser = isPlatformBrowser(this.platformId);
  private resizeObserver?: ResizeObserver
  private adFlowService = inject(AdvertisementFlowService);
  private ngZone = inject(NgZone)
  private spinnerService = inject(SpinnerService);
  private productService = inject(ProductService);
  private promoService = inject(PromosService);
  private notificationService = inject(NotificationService);
  private cartService = inject(CartService);
  private injector = inject(Injector);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private configStore = inject(ConfigurationStore);
  private dialog = inject(MatDialog);
  private bundleService = inject(BundleService);
  private categoryStore = inject(CategoryStore);
  private orderContextStore = inject(OrderContextStore);
  private responseInit = inject(RESPONSE_INIT)
  private request = inject(REQUEST)
  protected readonly themeConfig = inject(THEME_CONFIG)
  private tenantService = inject(TenantService);
  isMilano = false;
  private customerService = inject(CustomerService);
  private advertisementService = inject(AdvertisementService);
  private authenticationService = inject(AuthenticationService);
  private advertisementQueue: any[] = [];
  private readonly SEEN_ADS_STORAGE_KEY = 'seen_advertisements';

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('promoScrollContainer') promoScrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('menusScrollContainer') menusScrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('categoriesContainer') categoriesContainer!: ElementRef;
  readonly FORTY_DAYS_MS = 40 * 24 * 60 * 60 * 1000;

  data = this.categoryStore.selectCategories();
  selectedOrderType = this.orderContextStore.orderType;
  selectedCityName = this.orderContextStore.cityName;
  selectedZipCode = this.orderContextStore.zipcode;
  cityId = this.orderContextStore.cityId;
  deliveryDelay = this.orderContextStore.deliveryDelay;
  minOrderAmounts = this.orderContextStore.minOrderAmounts;
  readonly restaurantAddress = this.configStore.address;

  readonly isLoading = signal<boolean>(true);
  readonly isLoadingMenus = signal<boolean>(false);
  readonly isLoadingPromos = signal<boolean>(false);
  readonly hasMenus = signal<boolean>(false);
  readonly hasPromos = signal<boolean>(false);
  menusLoaded = signal<boolean>(false);
  promosLoaded = signal<boolean>(false);
  readonly selectedCategory = signal<string | null>(null)
  private readonly REDEEM_PROMO_TYPE = 'loyalty-point-redemption';
  private readonly DEFAULT_PROMO_TYPES = ['product-offer', 'order-offer'];
  private sortedPromos: any[] = [];
  private discountCache = new Map<string, any>();
  private lastRedeemMode: boolean | null = null;
  productsByCategory: any[] = [];
  dataPromos: any[] = [];
  dataMenus: any[] = [];
  productDiscountPromos: any[] = [];
  private rawDataMenus: any[] = [];
  activeSubcategories: any[] = [];
  productSizeOptions = new Map<any, Array<{ size: string; price: number; sizeId: string | null }>>();
  productCustomizationInfo = new Map<string, boolean>();

  totalPages = 0;
  totalElements = 0;
  currentCategoryId: string | null = null;
  currentCategorySlug: string | null = null;

  readonly FILTER_ID = '__filter'
  readonly MENU_ID = 'nos_menu'
  readonly PROMO_ID = 'nos_promos'

  activeIngredients: string[] = [];
  activeIngredientFlags: string[] = [];
  isFilterDialogOpen = false;
  activeFilterLabels: { plus: string[]; minus: string[] } = {plus: [], minus: []};
  activeFiltersCount = 0;

  private isDown = false;
  private startX!: number;
  private scrollLeft!: number;
  canScrollLeft = false;
  canScrollBundleLeft = false;
  canScrollRight = true;
  canScrollBundleRight = true;
  hasOverflow = signal<boolean>(false);
  hasOverflowMenus = signal<boolean>(false);
  showSeeMore = false;
  showSeeMoreMenus = false;
  private now = signal(Date.now());
  readonly loyaltyUnitCost = this.configStore.loyaltyUnitCost;

  backgroundImages = [
    '/assets/images/background-bundle-1.webp',
    '/assets/images/background-bundle-2.webp',
  ];

  TextClasses = ['#B74C2B', '#FFB936'];

  private readonly promoColors = [
    {bg: 'bg-[#B74C2B]', text: 'text-white'},
    {bg: 'bg-[#FFB936]', text: 'text-dark'}
  ];

  get page(): number {
    return +(this.route.snapshot.queryParamMap.get('page') || 0);
  }

  get size(): number {
    return +(this.route.snapshot.queryParamMap.get('size') || 50);
  }

  get selectedSubcategoryId(): string | null {
    return this.route.snapshot.queryParamMap.get('subcategory');
  }

  hasAdditions(product: any): boolean {
    return product.containAdditions === true;
  }

  get isMenusActive(): boolean {
    return this.selectedCategory() === this.MENU_ID;
  }

  get isPromosActive(): boolean {
    return this.selectedCategory() === this.PROMO_ID;
  }

  get isFiltersActive(): boolean {
    return this.selectedCategory() === this.FILTER_ID;
  }

  get isTakeawayOrOnSite(): boolean {
    const orderType = this.selectedOrderType();
    return orderType === TypeOrderEnum.TAKEAWAY || orderType === TypeOrderEnum.ON_SITE;
  }

  get isDelivery(): boolean {
    return this.selectedOrderType() === TypeOrderEnum.DELIVERY;
  }

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      setInterval(() => this.now.set(Date.now()), 60_000);
    }
    effect(() => {
      this.data()
      this.checkMenusAndPromosExist();
    })
  }

  ngOnInit() {
    this.isMilano = this.tenantService.getActiveTenant() === 'milano';
    this.loadLoyaltyBalance();
    this.initializeOrderTypeStream();
    this.initializePromosStream();

    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const catSlug = params['catSlug'];
      // Ne pas écraser si on est actuellement sur un onglet virtuel (Filtre, Menus, Promos)
      if (
        catSlug &&
        this.selectedCategory() !== this.FILTER_ID &&
        this.selectedCategory() !== this.MENU_ID &&
        this.selectedCategory() !== this.PROMO_ID
      ) {
        this.selectedCategory.set(catSlug);
      }
    });

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const categoryQueryParam = params['category'];
      const categoryPathParam = this.route.snapshot.params['catSlug'];

      // 1. PRIORITÉ ABSOLUE aux onglets virtuels (__filter, nos_menu, nos_promos) s'ils sont dans queryParams
      if (
        categoryQueryParam === this.FILTER_ID ||
        categoryQueryParam === this.MENU_ID ||
        categoryQueryParam === this.PROMO_ID
      ) {
        this.selectedCategory.set(categoryQueryParam);
      } else {
        this.selectedCategory.set(categoryPathParam ?? categoryQueryParam);
      }

      // 2. Exécution du chargement selon l'onglet actif
      if (this.isMenusActive) {
        this.getBundle();
      } else if (this.isPromosActive) {
        this.getPromotions(this.promoTypes, '');
      } else if (this.isFiltersActive) {
        const ingParam = params['ingredients'];
        const flagsParam = params['flags'];
        const plusLabelsParam = params['plusLabels'];
        const minusLabelsParam = params['minusLabels'];

        this.activeIngredients = ingParam ? ingParam.split(',') : [];
        this.activeIngredientFlags = flagsParam ? flagsParam.split(',') : [];
        this.activeFilterLabels = {
          plus: plusLabelsParam ? plusLabelsParam.split(',') : [],
          minus: minusLabelsParam ? minusLabelsParam.split(',') : []
        };
        this.activeFiltersCount = this.activeIngredients.length + this.activeIngredientFlags.length;

        // Déclenche la recherche filtrée
        this.getProductsByFilters();
      } else if (this.selectedCategory()) {
        untracked(() => this.resolveAndLoadCategory(this.selectedCategory() ?? ''));
      }
    });

    this.getCategory();
  }
  readonly loyaltyPointEnabled = this.configStore.loyaltyPointEnabled;
  readonly loyaltyBalance = signal<number | null>(null);
  readonly hasLoyaltyPoints = computed(() => (this.loyaltyBalance() ?? 0) > 0);
  get availablePoints(): number {
    const balance = this.loyaltyBalance();
    if (balance === null) return 0;
    return Math.max(balance - this.getPointsAlreadyInCart(), 0);
  }
  private loadLoyaltyBalance(): void {
    if (!this.isBrowser || !this.loyaltyPointEnabled()) return;

    this.customerService.getProfile().pipe(
      map((res: any) => Number(res.body?.data?.loyaltyPoints ?? 0)),
      catchError(() => of(null)),
      takeUntil(this.destroy$)
    ).subscribe(balance => this.loyaltyBalance.set(balance));
  }
  private get promoTypes(): string[] {
    const redeem = this.route.snapshot.queryParamMap.get('mode') === 'redeem';
    return redeem ? [this.REDEEM_PROMO_TYPE] : this.DEFAULT_PROMO_TYPES;
  }

  get isRedeemMode(): boolean {
    return this.route.snapshot.queryParamMap.get('mode') === 'redeem' && !!this.loyaltyUnitCost();
  }

  toPoints(price: number): number {
    const unit = this.loyaltyUnitCost();
    return unit ? Math.round(price * 100 * unit) : 0;
  }

  displayPrice(price: number, currency?: string): string {
    if (this.isRedeemMode) return `${this.toPoints(price)} pts`;
    return `${this.truncate2(price).toFixed(2)} ${currency ?? ''}`.trim();
  }

  getMenuPrice(card: any): string {
    if (this.isRedeemMode && card.price != null) return `${this.toPoints(Number(card.price))} pts`;
    return card.formattedPrice || `${card.price} ${card.currency || '€'}`;
  }

  private getSeenAdvertisementIds(): string[] {
    if (!this.isBrowser) return [];
    try {
      const raw = localStorage.getItem(this.SEEN_ADS_STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  private markAdvertisementAsSeen(adId: string): void {
    if (!this.isBrowser) return;
    const seenIds = this.getSeenAdvertisementIds();
    if (!seenIds.includes(adId)) {
      seenIds.push(adId);
      localStorage.setItem(this.SEEN_ADS_STORAGE_KEY, JSON.stringify(seenIds));
    }
  }

  private checkAndShowAdvertisement(): void {
    if (!this.isBrowser) return;
    this.adFlowService.checkAndShowAdvertisements(this.cityId(), this.isDelivery);
  }

  openDialog(categoryId?: string) {
    const dialogRef = this.dialog.open(OrderComponent, {
      panelClass: 'custom-dialog',
      autoFocus: false,
      disableClose: true,
      data: {selectedCategoryId: categoryId, stayOnProductPage: true, disableNavigation: true}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.checkAndShowAdvertisement();
    });
  }

  get groupedProductsByCategory(): { label: string; products: any[] }[] {
    if (this.selectedSubcategoryId || !this.activeSubcategories?.length) {
      return [{label: '', products: this.productsByCategory}];
    }

    const groups: { label: string; products: any[] }[] = [];
    const assignedIds = new Set<string>();

    for (const sub of this.activeSubcategories) {
      const items = this.productsByCategory.filter(
        (p: any) => p.category?.id === sub.id || p.categoryId === sub.id
      );
      if (items.length > 0) {
        groups.push({label: sub.name, products: items});
        items.forEach((p: any) => assignedIds.add(p.id));
      }
    }

    const rest = this.productsByCategory.filter((p: any) => !assignedIds.has(p.id));
    if (rest.length > 0) {
      groups.unshift({label: '', products: rest});
    }

    return groups.length > 0 ? groups : [{label: '', products: this.productsByCategory}];
  }

  private computeIsAvailable(item: any, now: number): boolean {
    if (!item.activatesAt) return true;
    return new Date(item.activatesAt).getTime() <= now;
  }

  private computeAvailabilityLabel(item: any, now: number): string | null {
    if (!item.activatesAt || this.computeIsAvailable(item, now)) return null;

    const activatesAtDate = new Date(item.activatesAt);
    const nowDate = new Date(now);

    const isSameDay =
      activatesAtDate.getFullYear() === nowDate.getFullYear() &&
      activatesAtDate.getMonth() === nowDate.getMonth() &&
      activatesAtDate.getDate() === nowDate.getDate();

    if (isSameDay) {
      const time = activatesAtDate.toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      });
      return `Disponible à ${time}`;
    }

    const formatted = activatesAtDate.toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
    return `Disponible à partir du ${formatted}`;
  }

  private filterByActivationWindow(items: any[]): any[] {
    const now = this.now();

    const filtered = items.filter((item: any) => {
      if (!item.activatesAt || !item.expiresAt) return true;

      const activatesAtTime = new Date(item.activatesAt).getTime();
      const expiresAtTime = new Date(item.expiresAt).getTime();

      const isCurrentlyActive = now >= activatesAtTime && now <= expiresAtTime;

      const isUpcomingWithin40Days = activatesAtTime > now && activatesAtTime <= now + this.FORTY_DAYS_MS;

      return isCurrentlyActive || isUpcomingWithin40Days;
    });

    return filtered.map((item: any) => ({
      ...item,
      _isAvailable: this.computeIsAvailable(item, now),
      _availabilityLabel: this.computeAvailabilityLabel(item, now),
    }));
  }
  private initializePromosStream() {
    combineLatest([
      this.route.queryParamMap.pipe(
        map(p => p.get('mode') === 'redeem'),
        distinctUntilChanged()
      ),
      toObservable(this.selectedOrderType, {injector: this.injector})
    ]).pipe(
      tap(() => this.isLoadingPromos.set(true)),
      switchMap(([redeem, orderType]) =>
        this.promoService
          .getAllPomotions(redeem ? [this.REDEEM_PROMO_TYPE] : this.DEFAULT_PROMO_TYPES, '')
          .pipe(
            map(result => ({result, orderType})),
            catchError(() => of(null))
          )
      ),
      takeUntil(this.destroy$)
    ).subscribe(res => {
      if (!res?.result) {
        this.hasPromos.set(false);
        this.isLoadingPromos.set(false);
        return;
      }

      const promos = (res.result?.body?.data || [])
        .map((promo: any) => ({
          ...promo,
          orderTypes: (promo.payload?.orderTypes || []).map(
            (type: string) => TypeOrderEnum[type as keyof typeof TypeOrderEnum] ?? type
          )
        }))
        .filter((promo: any) => promo.orderTypes.includes(res.orderType))
        .sort((a: any, b: any) => (a.type === 'product-offer' ? 0 : 1) - (b.type === 'product-offer' ? 0 : 1));

      this.dataPromos = this.filterByActivationWindow(promos);
      this.hasPromos.set(this.dataPromos.length > 0);
      if (this.isPromosActive) this.promosLoaded.set(true);
      this.isLoadingPromos.set(false);
    });
  }
  private initializeOrderTypeStream() {
    toObservable(this.selectedOrderType, {injector: this.injector}).pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if (this.currentCategoryId && !this.isMenusActive && !this.isPromosActive) {
        this.loadProductDiscountPromos(this.currentCategoryId);
      }
      this.filterMenusByOrderType();
    });
  }
  initPromoDiscounts() {
    this.sortedPromos = [...this.productDiscountPromos].sort((a, b) =>
      new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime());
    this.discountCache.clear();
  }

  private resolveAndLoadCategory(categoryParam: string) {
    const categories = this.data();
    if (!categories || categories.length === 0) return;

    const found = categories.find(c => c.slug === categoryParam || c.id === categoryParam);
    if (found) {
      this.currentCategoryId = found.id;
      this.currentCategorySlug = found.slug
      if (!found.isActive) {
        untracked(() => this.categoryStore.setActiveCategory(found.id));
      }
      this.activeSubcategories = found.children?.filter((c: any) => c.products > 0) || [];

      const targetId = this.selectedSubcategoryId || found.id;
      const parentId = this.selectedSubcategoryId ? found.id : undefined;

      this.getProductsByCategory(targetId);
      this.getBundle(targetId)
      this.loadProductDiscountPromos(targetId, parentId);
    } else {
      this.isLoading.set(false);
    }
  }

  getCategory() {
    this.categoryStore.loadCategories();

    effect(() => {
      const categories = this.data();
      if (!categories || categories.length === 0) return;

      if (this.selectedCategory()
        && this.selectedCategory() !== this.MENU_ID
        && this.selectedCategory() !== this.PROMO_ID
        && this.selectedCategory() !== this.FILTER_ID) {
        untracked(() => this.resolveAndLoadCategory(this.selectedCategory() ?? ''));
      }
    }, {injector: this.injector});
  }

  getProductsByCategory(categoryId: string) {
    this.productsByCategory = [];
    this.productCustomizationInfo.clear();
    this.productSizeOptions.clear();
    this.totalPages = 0;
    this.totalElements = 0;
    this.isLoading.set(true);
    this.spinnerService.show();

    this.productService.getPublicProduct(this.page, this.size, categoryId).pipe(
      catchError((err) => {
        this.notificationService.errorHandler(err);
        this.isLoading.set(false);
        this.spinnerService.hide();
        this.productsByCategory = [];
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe((result) => {
      if (!result) return;

      const pageData = result.body?.data;
      this.totalPages = pageData.totalPages;
      this.totalElements = pageData.totalElements;

      let products = result.body?.data.content || [];

      if (this.isRedeemMode) {
        products = products.filter((p: any) => p.redeemable === true);
      }

      const now = this.now();
      products.forEach((p: any) => {
        this.initializeQuickPriceAndSizes(p);
        const hasCustomization =
          (p.containAdditions === true) ||
          (p.containSupplements === true) ||
          (p.ingredients?.length > 0);

        this.productCustomizationInfo.set(p.id, hasCustomization);
        p._isAvailable = p.available && this.computeIsAvailable(p, now);
        p._availabilityLabel = this.computeAvailabilityLabel(p, now);
      });

      this.productsByCategory = products;
      this.spinnerService.hide();
      this.isLoading.set(false);
    });
  }
  getProductsByFilters() {
    this.productsByCategory = [];
    this.productCustomizationInfo.clear();
    this.productSizeOptions.clear();
    this.isLoading.set(true);
    this.spinnerService.show();

    this.productService.getPublicProduct(
      this.page,
      this.size,
      null,
      this.activeIngredients.length > 0 ? this.activeIngredients : undefined,
      this.activeIngredientFlags.length > 0 ? this.activeIngredientFlags : undefined
    ).pipe(
      catchError((err) => {
        this.notificationService.errorHandler(err);
        this.isLoading.set(false);
        this.spinnerService.hide();
        this.productsByCategory = [];
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe((result) => {
      if (!result) return;

      const pageData = result.body?.data;
      this.totalPages = pageData.totalPages;
      this.totalElements = pageData.totalElements;

       let products = result.body?.data.content || [];
      if (this.isRedeemMode) {
        products = products.filter((p: any) => p.redeemable === true);
      }
      const now = this.now();
      products.forEach((p: any) => {
        this.initializeQuickPriceAndSizes(p);
        const hasCustomization =
          (p.containAdditions === true) ||
          (p.containSupplements === true) ||
          (p.ingredients?.length > 0);
        this.productCustomizationInfo.set(p.id, hasCustomization);
        p._isAvailable = p.available && this.computeIsAvailable(p, now);
        p._availabilityLabel = this.computeAvailabilityLabel(p, now);
      });

      this.productsByCategory = products;
      this.spinnerService.hide();
      this.isLoading.set(false);
    });
  }

  private checkMenusAndPromosExist() {
    let menusData: any[] = [];
    let promosData: any[] = [];

    const currentParam = this.selectedCategory()
    if (currentParam) return;
    const firstCategory = this.data()?.find((c: any) => c.products !== 0);
    if (firstCategory) {
      if (isPlatformBrowser(this.platformId)) {
        this.router.navigate(['/product/category', firstCategory.slug], {
          queryParams: { page: 0 },
          queryParamsHandling: 'merge'
        });
      }
      if (isPlatformServer(this.platformId)) {
        if (this.responseInit) {
          const resInit = this.responseInit
          const targetUrl = `${this.request?.url}?category=${firstCategory.slug}`;
          resInit.status = 302;
          resInit.headers = resInit.headers || new Headers();
          if (resInit.headers instanceof Headers) {
            resInit.headers.set('Location', targetUrl);
          } else {
            (this.responseInit.headers as any)['Location'] = targetUrl;
          }
        } else {
          console.warn("Response INIT is NULL")
        }
        return
      }
    }

    this.bundleService.getAllBundle().pipe(
      catchError(() => {
        menusData = [];
        this.hasMenus.set(false);
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe(result => {
      if (result) {
        const orderType = this.selectedOrderType();
        let rawMenus = (result?.body?.data.items || [])
          .map((menu: any) => ({
            ...menu,
            orderTypes: (menu.orderTypes || []).map(
              (type: string) => TypeOrderEnum[type as keyof typeof TypeOrderEnum] ?? type
            )
          }))
          .filter((menu: any) => menu.orderTypes.includes(orderType));
        if (this.isRedeemMode) {
          rawMenus = rawMenus.filter((menu: any) => menu.redeemable === true);
        }
        menusData = this.filterByActivationWindow(rawMenus);
        this.hasMenus.set(menusData.length > 0);
      }
    });

    this.promoService.getAllPomotions(this.promoTypes, '').pipe(
      catchError(() => {
        promosData = [];
        this.hasPromos.set(false);
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe(result => {
      if (result) {
        const orderType = this.selectedOrderType();
        const rawPromos = (result?.body?.data || [])
          .map((promo: any) => ({
            ...promo,
            orderTypes: (promo.payload?.orderTypes || []).map(
              (type: string) => TypeOrderEnum[type as keyof typeof TypeOrderEnum] ?? type
            )
          }))
          .filter((promo: any) => promo.orderTypes.includes(orderType))
          .sort((a: any, b: any) => (a.type === 'product-offer' ? 0 : 1) - (b.type === 'product-offer' ? 0 : 1));

        promosData = this.filterByActivationWindow(rawPromos);
        this.hasPromos.set(promosData.length > 0);
      }
    });
  }

  getPromotions(t: string[], cat: string) {
    if (!cat) this.isLoadingPromos.set(true);
    this.spinnerService.show();

    this.promoService.getAllPomotions(t, cat).pipe(
      catchError((err) => {
        this.notificationService.errorHandler(err);
        this.isLoadingPromos.set(false);
        this.spinnerService.hide();
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe(result => {
      if (!result) {
        this.promosLoaded.set(true);
        return;
      }
      const orderType = this.selectedOrderType();
      const promos = (result.body?.data || [])
        .map((promo: any) => ({
          ...promo,
          orderTypes: (promo.payload?.orderTypes || []).map(
            (type: string) => TypeOrderEnum[type as keyof typeof TypeOrderEnum] ?? type
          )
        }))
        .filter((promo: any) => promo.orderTypes.includes(orderType))
        .sort((a: any, b: any) => {
          const order = (type: string) => type === 'product-offer' ? 0 : 1;
          return order(a.type) - order(b.type);
        });

      this.dataPromos = this.filterByActivationWindow(promos);

      this.spinnerService.hide();
      this.isLoadingPromos.set(false);
    });
  }

  loadProductDiscountPromos(targetId: string, parentCategoryId?: string): void {
    this.productDiscountPromos = [];

    this.promoService.getAllPomotions(['product-discount'], '').pipe(
      catchError(() => of(null)),
      takeUntil(this.destroy$)
    ).subscribe(result => {
      if (!result) return;
      const orderType = this.selectedOrderType();

      this.productDiscountPromos = (result?.body?.data || [])
        .map((promo: any) => ({
          ...promo,
          orderTypes: (promo.payload?.orderTypes || []).map(
            (type: string) => TypeOrderEnum[type as keyof typeof TypeOrderEnum] ?? type
          )
        }))
        .filter((promo: any) => promo.orderTypes.includes(orderType))
        .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .filter((promo: any) => {
          const rules: any[] = promo.payload?.rules || [];
          return rules.some(rule => {
            const ruleCategoryId = rule.category?.id;
            if (ruleCategoryId === targetId) return true;
            return !!(parentCategoryId && ruleCategoryId === parentCategoryId);
          });
        });
      this.initPromoDiscounts()
    });
  }

  getBundle(id?: string) {
    this.isLoadingMenus.set(true);
    this.spinnerService.show();

    this.bundleService.getAllBundle(id).pipe(
      catchError((err) => {
        this.notificationService.errorHandler(err);
        this.spinnerService.hide();
        this.isLoadingMenus.set(false);
        this.hasMenus.set(false);
        this.menusLoaded.set(true);
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe(result => {
      if (!result) {
        this.menusLoaded.set(true);
        return;
      }
      this.spinnerService.hide();
      this.isLoadingMenus.set(false);

      this.rawDataMenus = result.body?.data.items || [];
      this.filterMenusByOrderType();

      this.menusLoaded.set(true);
    });
  }

  private filterMenusByOrderType(): void {
    const orderType = this.selectedOrderType();
    let menus = (this.rawDataMenus || [])
      .map((menu: any) => ({
        ...menu,
        orderTypes: (menu.orderTypes || []).map(
          (type: string) => TypeOrderEnum[type as keyof typeof TypeOrderEnum] ?? type
        )
      }))
      .filter((menu: any) => menu.orderTypes.includes(orderType));

    if (this.isRedeemMode) {
      menus = menus.filter((menu: any) => menu.redeemable === true);
    }

    this.dataMenus = this.filterByActivationWindow(menus);

    this.hasMenus.set(this.dataMenus.length > 0);
  }
  onSizeChange(product: any, event: any): void {
    const selectedSizeName = event.value;
    const options = this.productSizeOptions.get(product);

    if (options) {
      const selected = options.find(opt => opt.size === selectedSizeName);
      if (selected) {
        product.selectedSize = selected.size;
        product.selectedPrice = selected.price;
        product.selectedSizeId = selected.sizeId || null;
      }
    }

    this.productsByCategory = [...this.productsByCategory];

    this.productService.getProductById(product.id).pipe(
      catchError(() => of(null)),
      takeUntil(this.destroy$)
    ).subscribe(result => {
      if (result?.body?.data) {
        const needsCustom = this.checkIfNeedsCustomization(result.body.data, selectedSizeName);
        this.productCustomizationInfo.set(product.id, needsCustom);
      }
    });
  }
  private getPointsAlreadyInCart(): number {
    return this.cartService.totalPointsInCart();
  }
  private verifyPointsThen(needed: number, onOk: () => void): void {
    this.customerService.getProfile().pipe(
      map((res: any) => Number(res.body?.data?.loyaltyPoints ?? 0)),
      catchError(() => of(null)),
      takeUntil(this.destroy$)
    ).subscribe(balance => {
      if (balance == null) {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          'Connexion requise',
          'Veuillez vous connecter à votre compte pour utiliser vos points de fidélité.'
        );
        return;
      }

      const inCart = this.getPointsAlreadyInCart();
      const available = Math.max(balance - inCart, 0);

      if (needed > available) {
        let detailMsg = `Cet article nécessite ${needed} pts, mais vous n'avez que ${available} pts disponibles.`;

        if (inCart > 0) {
          detailMsg += ` (Solde total : ${balance} pts, dont ${inCart} pts déjà utilisés dans votre panier).`;
        }

        this.notificationService.sendNotification(
          NotificationType.ERROR,
          'Solde de points insuffisant',
          detailMsg
        );
        return;
      }

      onOk();
    });
  }
  addDirectlyToCart(product: any): void {
    if (!product) return;

    const redeem = this.isRedeemMode;

    const existingProduct = this.cartService.productItems().find(
      item => item.product.id === product.id
    );

    if (existingProduct) {
      if (redeem && !existingProduct.redeemWithPoints) {
        this.notificationService.sendNotification(
          NotificationType.WARNING,
          `"${product.name}" est déjà dans votre panier en version payante. Retirez-le du panier si vous souhaitez l'échanger avec vos points.`,
          ''
        );
        return;
      }

      if (!redeem && existingProduct.redeemWithPoints) {
        this.notificationService.sendNotification(
          NotificationType.WARNING,
          `"${product.name}" est déjà dans votre panier en version points de fidélité. Retirez-le si vous souhaitez l'acheter en Euros.`,
          ''
        );
        return;
      }
    }

    this.productService.getProductById(product.id).pipe(
      catchError(() => of(null)),
      takeUntil(this.destroy$)
    ).subscribe(fullProduct => {
      if (!fullProduct?.body?.data) return;

      const productDetails = fullProduct.body.data;
      const productImage = product.cover || 'assets/images/no-product.webp';

      let selectedSizeId: string | null = null;
      let selectedPrice = 0;

      if (productDetails.pricePerSizes?.length > 0) {
        if (product.selectedSize) {
          const sizeObj = productDetails.pricePerSizes.find((pps: any) => pps.size.name === product.selectedSize);
          selectedSizeId = sizeObj?.size?.id || productDetails.pricePerSizes[0].size.id;
          selectedPrice = sizeObj?.price || productDetails.pricePerSizes[0].price;
        } else {
          selectedSizeId = productDetails.pricePerSizes[0].size.id;
          selectedPrice = productDetails.pricePerSizes[0].price;
        }
      } else {
        selectedPrice = productDetails.price || 0;
      }

      const selectedIngredients = productDetails.ingredients?.map((i: any) => i.id) || [];
      const discountInfo = this.getProductDiscountInfo(product.id, product.selectedSize);
      const effectivePrice = discountInfo
        ? Math.max(0, this.calculateDiscountedPrice(selectedPrice, discountInfo.reduction))
        : selectedPrice;
      const pointsCost = redeem ? this.toPoints(selectedPrice) : null;

      const addToCart = () => {
        this.cartService.addProduct({
          product: productDetails,
          productImage: productImage,
          selectedSize: selectedSizeId,
          selectedPrice: redeem ? 0 : effectivePrice,
          quantity: 1,
          selectedIngredients: selectedIngredients,
          excludedIngredients: [],
          selectedAdditions: {},
          selectedSupplements: {},
          total: redeem ? 0 : effectivePrice,
          redeemWithPoints: redeem,
          pointsCost,
          discountActivatedFor: discountInfo?.activatedFor || [],
          discountOrderTypes: discountInfo?.orderTypes || [],
          discountPromotionId: discountInfo?.promoId || null,
          reduction: discountInfo?.reduction || null
        });

        this.notificationService.sendNotification(NotificationType.SUCCESS, `${product.name} ajouté au panier`, '');
      };

      if (redeem) {
        this.verifyPointsThen(pointsCost!, addToCart);
      } else {
        addToCart();
      }
    });
  }

  nextPage() {
    if (this.page + 1 >= this.totalPages) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {page: this.page + 1},
      queryParamsHandling: 'merge'
    });
    this.scrollToCategoriesHeader();
  }

  prevPage() {
    if (this.page === 0) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {page: this.page - 1},
      queryParamsHandling: 'merge'
    });
    this.scrollToCategoriesHeader();
  }

  private scrollToCategoriesHeader() {
    if (!this.isBrowser) return;
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const categoriesElement = document.querySelector('.categories-scroll-container');
        if (categoriesElement) {
          categoriesElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        } else {
          window.scrollTo({top: 0, behavior: 'smooth'});
        }
      }, 100);
    })
  }

  navigateToProductDetailsSideEffect(product: any) {
    if (!product._isAvailable) return;
    if (this.isBrowser) {
      sessionStorage.setItem('productPageState', JSON.stringify({
        currentCategoryId: this.currentCategoryId,
        isMenusActive: this.isMenusActive,
        isPromosActive: this.isPromosActive,
        isFiltersActive: this.isFiltersActive,
        page: this.page,
        activeIngredients: this.activeIngredients,
        activeIngredientFlags: this.activeIngredientFlags,
        activeFilterLabels: this.activeFilterLabels,
        activeFiltersCount: this.activeFiltersCount,
        selectedSubcategoryId: this.selectedSubcategoryId,
        activeSubcategories: this.activeSubcategories
      }));
    }

    this.router.navigate(
      ['/product', this.currentCategorySlug ?? product.category.slug, product.slug],
      {
        queryParams: {size: product?.selectedSize ?? null, mode: this.isRedeemMode ? 'redeem' : null},
        state: {
          returnToCommand: false,
          slug: product.slug,
          editingCartItemId: false,
          selectedSize: product.selectedSize,
          selectedPrice: product.selectedPrice,
          discountReduction: this.getProductDiscountInfo(product.id, product.selectedSize)?.reduction || null,
          discountActivatedFor: this.getProductDiscountInfo(product.id, product.selectedSize)?.activatedFor || [],
          discountOrderTypes: this.getProductDiscountInfo(product.id, product.selectedSize)?.orderTypes || [],
          discountPromotionId: this.getProductDiscountInfo(product.id, product.selectedSize)?.promoId || null,
        }
      }
    );
  }

  redirectVersDetailsBundleSideEffect() {
    if (this.isBrowser) {
      sessionStorage.setItem('productPageState', JSON.stringify({
        currentCategoryId: this.currentCategoryId,
        isMenusActive: this.isMenusActive,
        isPromosActive: this.isPromosActive,
        isFiltersActive: this.isFiltersActive
      }));
    }
  }

  redirectVersDetailsPromosSideEffect() {
    if (this.isBrowser) {
      sessionStorage.setItem('productPageState', JSON.stringify({
        currentCategoryId: this.currentCategoryId,
        isMenusActive: this.isMenusActive,
        isPromosActive: this.isPromosActive,
        isFiltersActive: this.isFiltersActive,
        selectedSubcategoryId: this.selectedSubcategoryId,
        activeSubcategories: this.activeSubcategories
      }));
    }
  }

  openFilterDialog() {
    this.isFilterDialogOpen = true;
    const dialogRef = this.dialog.open(ProductFilterDialogComponent, {
      panelClass: 'custom-dialog',
      maxWidth: '700px',
      data: {
        activeIngredientFlags: this.activeIngredientFlags,
        activeIngredients: this.activeIngredients,
        plusLabels: this.activeFilterLabels.plus,
        minusLabels: this.activeFilterLabels.minus
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.isFilterDialogOpen = false;

      // Si l'utilisateur clique sur "Annuler" ou ferme le dialog
      if (!result || result.clear) {
        this.activeIngredients = [];
        this.activeIngredientFlags = [];
        this.activeFilterLabels = { plus: [], minus: [] };
        this.activeFiltersCount = 0;

        // Nettoyer l'URL et revenir à la catégorie courante
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            category: null,
            ingredients: null,
            flags: null,
            plusLabels: null,
            minusLabels: null,
            page: 0
          },
          queryParamsHandling: 'merge'
        });
        return;
      }

      const flags = [
        ...result.flagsPlus.map((id: string) => `+${id}`),
        ...result.flagsMinus.map((id: string) => `-${id}`)
      ];
      const ingredients = [
        ...result.ingredientsPlus.map((id: string) => `+${id}`),
        ...result.ingredientsMinus.map((id: string) => `-${id}`)
      ];
      const plus = result.plusLabels || [];
      const minus = result.minusLabels || [];

      if (flags.length + ingredients.length > 0) {
        this.selectFilters({ ingredients, flags, plus, minus });
      } else {
        // Si aucune case n'a été cochée lors de la validation, réinitialiser
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            category: null,
            ingredients: null,
            flags: null,
            plusLabels: null,
            minusLabels: null,
            page: 0
          },
          queryParamsHandling: 'merge'
        });
      }
    });
  }
  ngAfterViewInit() {
    if (!this.isBrowser) return

    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflow()
    })

    if (this.promoScrollContainer?.nativeElement) {
      this.resizeObserver.observe(this.promoScrollContainer.nativeElement)
    }
    if (this.menusScrollContainer?.nativeElement) {
      this.resizeObserver.observe(this.menusScrollContainer.nativeElement)
    }
  }

  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  @HostListener('window:scroll')
  onResize() {
    if (this.isBrowser) this.checkOverflow();
  }

  checkOverflow() {
    if (this.promoScrollContainer?.nativeElement) {
      const el = this.promoScrollContainer.nativeElement;
      this.hasOverflow.set(el.scrollWidth > el.clientWidth + 5);
      this.showSeeMore = this.hasOverflow();
      this.updateArrowPromosVisibility();
    }
    if (this.menusScrollContainer?.nativeElement) {
      const el = this.menusScrollContainer.nativeElement;
      this.hasOverflowMenus.set(el.scrollWidth > el.clientWidth + 5);
      this.showSeeMoreMenus = this.hasOverflowMenus();
      this.updateArrowVisibility();
    }
  }

  onMouseDown(e: MouseEvent): void {
    if (!this.isBrowser) return;
    this.isDown = true;
    this.scrollContainer.nativeElement.classList.add('active');
    this.startX = e.pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
  }

  onMouseMove(e: MouseEvent): void {
    if (!this.isBrowser || !this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - (x - this.startX) * 2;
  }

  onMouseUp(): void {
    if (!this.isBrowser) return;
    this.isDown = false;
    this.scrollContainer.nativeElement.classList.remove('active');
  }

  onMouseLeave(): void {
    this.onMouseUp();
  }

  onTouchStart(e: TouchEvent): void {
    if (!this.isBrowser) return;
    this.isDown = true;
    this.startX = e.touches[0].pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
  }

  onTouchMove(e: TouchEvent): void {
    if (!this.isBrowser || !this.isDown) return;
    const x = e.touches[0].pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - (x - this.startX) * 2;
  }

  onTouchEnd(): void {
    this.isDown = false;
  }

  scrollRightMenus(): void {
    if (!this.isBrowser || !this.menusScrollContainer?.nativeElement) return;
    const container = this.menusScrollContainer.nativeElement;
    if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 10) {
      container.scrollTo({left: 0, behavior: 'smooth'});
    } else {
      container.scrollTo({left: container.scrollLeft + 590, behavior: 'smooth'});
    }
  }

  scrollRight(): void {
    if (!this.isBrowser || !this.promoScrollContainer?.nativeElement) return;
    const container = this.promoScrollContainer.nativeElement;
    if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 10) {
      container.scrollTo({left: 0, behavior: 'smooth'});
    } else {
      container.scrollTo({left: container.scrollLeft + 632, behavior: 'smooth'});
    }
  }

  scrollRightBundle(): void {
    if (!this.isBrowser) return;
    this.menusScrollContainer.nativeElement.scrollBy({left: 320, behavior: 'smooth'});
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.updateArrowVisibility(), 400);
    })
  }

  scrollLeftBundle(): void {
    if (!this.isBrowser) return;
    this.menusScrollContainer.nativeElement.scrollBy({left: -320, behavior: 'smooth'});
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.updateArrowVisibility(), 400);
    })
  }

  scrollPromosLeft(): void {
    if (!this.isBrowser) return;
    this.promoScrollContainer.nativeElement.scrollBy({left: -320, behavior: 'smooth'});
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.updateArrowPromosVisibility(), 400);
    })
  }

  scrollPromosRight(): void {
    if (!this.isBrowser) return;
    this.promoScrollContainer.nativeElement.scrollBy({left: 320, behavior: 'smooth'});
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.updateArrowPromosVisibility(), 400);
    })
  }

  updateArrowVisibility() {
    if (!this.isBrowser || !this.menusScrollContainer) return;
    const el = this.menusScrollContainer.nativeElement;
    this.canScrollBundleLeft = el.scrollLeft > 10;
    this.canScrollBundleRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 10;
  }

  updateArrowPromosVisibility() {
    if (!this.isBrowser || !this.promoScrollContainer) return;
    const el = this.promoScrollContainer.nativeElement;
    this.canScrollLeft = el.scrollLeft > 10;
    this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 10;
  }

  isMobileAndCategorySelected(): boolean {
    if (!this.isBrowser) return false;
    const isMobile = window.innerWidth < 768;
    const categories = this.data();
    const hasCategorySelected = !!categories?.some(c => c.isActive);
    return isMobile && hasCategorySelected && !this.isMenusActive && !this.isPromosActive;
  }

  getProductDiscountInfo(productId: string, selectedSizeName?: string, productCategoryId?: string) {
    const cacheKey = `${productId}_${selectedSizeName || 'NONE'}`;
    if (this.discountCache.has(cacheKey)) {
      return this.discountCache.get(cacheKey);
    }
    const targetCategoryId = this.currentCategoryId || productCategoryId
    for (const promo of this.sortedPromos) {
      const rules = promo.payload?.rules || [];
      for (const rule of rules) {
        if (targetCategoryId && rule.category?.id !== targetCategoryId) continue;
        const hasProduct = (rule.products || []).some((p: any) => p.id === productId);
        if (!hasProduct) continue;
        if (rule.sizes && rule.sizes.length > 0) {
          if (!selectedSizeName) continue;
          const sizeMatch = rule.sizes.some((s: any) => s.name === selectedSizeName || s === selectedSizeName);
          if (!sizeMatch) continue;
        }
        const result = {
          reduction: promo.payload.reduction,
          activatedFor: promo.payload.activatedFor || [],
          orderTypes: promo.payload.orderTypes || [],
          promoId: promo.id || null
        };

        this.discountCache.set(cacheKey, result);
        return result;
      }
    }
    this.discountCache.set(cacheKey, null);
    return null;
  }

  initializeQuickPriceAndSizes(product: any): void {
    product.selectedSize = null;
    product.selectedPrice = null;
    product.selectedSizeId = null;
    if (product.price && typeof product.price === 'object' && !Array.isArray(product.price)) {
      const entries = Object.entries(product.price).filter(([_, val]) => typeof val === 'number' && val > 0).map(([size, price]) => ({
        size,
        price: Number(price)
      }));
      if (entries.length > 0) {
        const options = entries.map(e => ({size: e.size, price: e.price, sizeId: null}));
        this.productSizeOptions.set(product, options);
        product.selectedSize = options[0].size;
        product.selectedPrice = options[0].price;
      }
    } else if (typeof product.price === 'number' && product.price > 0) {
      product.selectedPrice = product.price;
    }
  }

  calculateDiscountedPrice(price: number, reduction: any): number {
    if (!reduction || !price) return price;

    let discountedPrice = price;

    if (reduction.type === 'PERCENTAGE') {
      discountedPrice = price * (1 - reduction.value);
    } else if (reduction.type === 'FIXED_AMOUNT') {
      discountedPrice = price - reduction.value;
    } else if (reduction.type === 'SET_PRICE') {
      discountedPrice = reduction.value;
    }

    return this.round2(Math.max(0, discountedPrice));
  }
  checkIfNeedsCustomization(fullProduct: any, selectedSize: string | null): boolean {
    if (fullProduct.ingredients?.length > 0 || fullProduct.supplements?.length > 0) return true;
    if (fullProduct.additions?.length > 0) {
      if (selectedSize) {
        return fullProduct.additions.some((addition: any) => !addition.sizes || addition.sizes.length === 0 || addition.sizes.some((s: any) => s.name === selectedSize));
      }
      return true;
    }
    return false;
  }

  selectCategory(categoryId: string) {
    // Réinitialiser les filtres en mémoire
    this.activeIngredients = [];
    this.activeIngredientFlags = [];
    this.activeFilterLabels = { plus: [], minus: [] };
    this.activeFiltersCount = 0;

    const category = this.data()?.find((c: any) => c.id === categoryId);

    // Naviguer vers la catégorie sans conserver les queryParams de filtre
    this.router.navigate(['/product/category', category?.slug || categoryId], {
      queryParams: {
        page: 0,
        mode: this.isRedeemMode ? 'redeem' : null,
        category: null,
        ingredients: null,
        flags: null,
        plusLabels: null,
        minusLabels: null
      }
    });
  }

  selectSubcategory(subcategoryId: string | null) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        subcategory: subcategoryId || null,
        page: 0
      },
      queryParamsHandling: 'merge'
    });
  }

  selectMenus() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {category: this.MENU_ID, page: 0},
      queryParamsHandling: 'merge'
    });
  }

  selectPromos() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {category: this.PROMO_ID, page: 0},
      queryParamsHandling: 'merge'
    });
  }

  selectFilters(filterData?: { ingredients: string[], flags: string[], plus: string[], minus: string[] }) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        category: this.FILTER_ID,
        ingredients: filterData ? filterData.ingredients.join(',') || null : (this.activeIngredients.join(',') || null),
        flags: filterData ? filterData.flags.join(',') || null : (this.activeIngredientFlags.join(',') || null),
        plusLabels: filterData ? filterData.plus.join(',') || null : (this.activeFilterLabels.plus.join(',') || null),
        minusLabels: filterData ? filterData.minus.join(',') || null : (this.activeFilterLabels.minus.join(',') || null),
        page: 0
      },
      queryParamsHandling: 'merge'
    });
  }

  addProductToCart(product: any): void {
    if (!product || !product.id) return;
    if (!product._isAvailable) return;
    this.addDirectlyToCart(product);
  }

  buildDiscountState(product: any) {
    const discountInfo = this.getProductDiscountInfo(product.id, product.selectedSize);
    return {
      slug: product.slug,
      selectedSize: product.selectedSize || null,
      selectedPrice: product.selectedPrice || product.price,
      discountReduction: discountInfo?.reduction || null,
      discountActivatedFor: discountInfo?.activatedFor || [],
      discountOrderTypes: discountInfo?.orderTypes || [],
      discountPromotionId: discountInfo?.promoId || null,
    };
  }

  getButtonLabel(product: any): string {
    return this.productCustomizationInfo.get(product.id) ? 'Personnaliser' : 'Ajouter au panier';
  }

  getButtonType(product: any): 'link' | 'button' {
    return this.productCustomizationInfo.get(product.id) ? 'link' : 'button';
  }

  getFormattedLocation() {
    if (this.isTakeawayOrOnSite) {
      return {
        text: this.restaurantAddress() || '',
        hasAddress: !!this.restaurantAddress()
      };
    }

    const city = this.selectedCityName() || '';
    const zip = this.selectedZipCode();
    const text = zip ? `${city} ${zip}` : city;

    return {text, hasAddress: false};
  }

  getOrderTypeLabel(): string {
    const labels: Record<TypeOrderEnum, string> = {
      [TypeOrderEnum.DELIVERY]: 'En Livraison',
      [TypeOrderEnum.TAKEAWAY]: 'À Emporter',
      [TypeOrderEnum.ON_SITE]: 'Sur Place'
    };
    return labels[this.selectedOrderType()!] || '';
  }

  getMinOrderAmount(): string {
    const amounts = this.minOrderAmounts();
    if (!amounts || amounts.length === 0) return '';
    const currentSeconds = (() => {
      const [h, m, s] = new Date().toTimeString().split(' ')[0].split(':').map(Number);
      return h * 3600 + m * 60 + s;
    })();
    const toSec = (t: string) => {
      const [h, m, s] = t.split(':').map(Number);
      return h * 3600 + m * 60 + s;
    };
    for (const slot of amounts) {
      const from = toSec(slot.from), to = toSec(slot.to);
      if ((from <= to && currentSeconds >= from && currentSeconds <= to) || (from > to && (currentSeconds >= from || currentSeconds <= to))) {
        return slot.amount === 0 ? '' : `Min Cmd: ${slot.amount.toFixed(2)}€`;
      }
    }
    return amounts[0].amount === 0 ? '' : `Min Cmd: ${amounts[0].amount.toFixed(2)}€`;
  }

  formatDeliveryDelay(): string {
    const delay = this.deliveryDelay();
    if (!delay) return '';
    const match = delay.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
    if (!match) return '';
    const h = match[1] ? parseInt(match[1]) : 0, m = match[2] ? parseInt(match[2]) : 0;
    return h > 0 && m > 0 ? `${h}h ${m}min` : h > 0 ? `${h}h` : `${m}min`;
  }

  getDiscountClientBadge(activatedFor: string[]) {
    if (!activatedFor || activatedFor.length === 0 || activatedFor.includes('ALL_CLIENTS')) return null;
    if (activatedFor.includes('NEW_CLIENT') && !activatedFor.includes('EXISTING_CLIENT')) return {
      label: 'Nouveau client',
      cssClass: 'bg-[#FF730AB2] text-white'
    };
    if (activatedFor.includes('EXISTING_CLIENT') && !activatedFor.includes('NEW_CLIENT')) return {
      label: 'Client existant',
      cssClass: 'bg-[#FF730AB2] text-white'
    };
    return null;
  }

  getPrimaryBadge(activatedFor: string[]) {
    if (!activatedFor || activatedFor.length === 0 || activatedFor.includes('ALL_CLIENTS')) return null;
    return {
      label: activatedFor.includes('NEW_CLIENT') ? 'Nouveau client' : activatedFor.includes('EXISTING_CLIENT') ? 'Client existant' : activatedFor[0],
      class: 'bg-orange-500 text-white animate-pulse'
    };
  }

  formatReduction = (r: any) =>
    r
      ? r.type === 'SET_PRICE'
        ? ''
        : r.type === 'PERCENTAGE'
          ? `-${Math.round(r.value * 100)}%`
          : `-${r.value}€`
      : '';
  getBackgroundImage = (i: number) => this.backgroundImages[i % this.backgroundImages.length];
  getButtonClass = (i: number) => this.getPromoColorClasses(i).bg;
  getColorText = (i: number) => this.TextClasses[i % this.TextClasses.length];
  getPromoColorClasses = (i: number) => this.promoColors[i % this.promoColors.length];
  hasMultiplePrices = (p: any) => p.price && typeof p.price === 'object' && !Array.isArray(p.price) && Object.keys(p.price).length > 1;
  isOrderOffer = (c: any) => c.type === 'order-offer';
  shouldShowMenusSection = () => this.isMenusActive || (!this.isFiltersActive && !this.isPromosActive && (this.dataMenus.length > 0 || this.isLoadingMenus()));
  isNaN = (v: any) => isNaN(v);
  truncate2 = (v: number) => Math.floor(v * 100) / 100;
  round2 = (v: number) => Math.round((v + Number.EPSILON) * 100) / 100;
  trackById = (item: any) => item.id;
  trackBySize = (i: number, opt: any) => opt.size;
  trackByProductId = (p: any) => p.id;
  openLoyaltyDialog(): void {
    if (!this.isRedeemMode) {
      this.dialog.open(LoyaltyPointComponent, {
        width: '900px',
        panelClass: 'custom-dialog',
        data: { points: this.availablePoints }
      });
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
